<template>
  <div>
    <div class="title">基本信息</div>
    <div>
    	<div class="item-wrap">
	    	<div class="item">
	    		<label>服务项目：</label>
		    	<el-select v-model="postData.server_uuid" placeholder="请选择服务项目" class="filter-item" clearable @change="selectProjectChange">
				    <el-option
				      v-for="item in servicelist"
				      :key="item.uuid"
				      :label="item.server_name"
				      :value="item.uuid">
				    </el-option>
				  </el-select>
				</div>
				<div class="item">
	    		<label>业务员：</label>
		    	<el-select v-model="postData.salesman_uuid" placeholder="请选择业务员">
	          <el-option
	            v-for="item in salesman_list"
	            :key="item.uuid"
	            :label="item.user_name"
	            :value="item.uuid">
	          </el-option>
	        </el-select>
				</div>
			</div>
		  <div class="item-wrap">
				<div class="item">
					<label>订单金额:</label>
					<el-input type="number" v-model="postData.order_total_price" placeholder="请选择服务项目" class="order_amount_input" :disabled="true"></el-input>
				</div>
				<div class="item">
					<label>佣金比例:</label>
					<el-input type="number" v-model="postData.commission_rate" placeholder="请输入内容" class="commission_rate_input"></el-input>
					<span>%</span>
				</div>
			</div>
			<div class="commodity_url_input-wrap">
				<label v-if="isTaobaoProject">商品链接:</label>
        <label v-else>店铺链接:</label>
				<el-input
          type="textarea"
          placeholder="请输入商品连接"
          v-model="postData.question_url"
          :rows="4"
          class="commodity_url_input"
          >
         </el-input>
			</div>
      <div class="commodity_url_input-wrap contact_remark">
				<label>联系方式备注:</label>
				<el-input
          type="textarea"
          placeholder="请输入联系方式备注"
          v-model="postData.order_remake"
          :rows="4"
          class="commodity_url_input"
          >
         </el-input>
			</div>
    </div>
    <div class="seller-info-wrap">
      <div class="title">商家信息</div>
      <div class="item" v-if="isTaobaoProject">
				<label>商家旺旺:</label>
				<el-input v-model="postData.merchant_wangwang" placeholder="请输入商家旺旺号" class="seller_wangwang"></el-input>
			</div>
			<div class="item">
				<label>手机号码:</label>
				<el-input v-model="postData.merchant_mobile" placeholder="请输入手机号码" class="merchant_mobile"></el-input>
			</div>
    </div>
    <div>
      <div class="title">消费者信息</div>
      <div class="item-wrap">
	      <div class="item" v-if="isTaobaoProject">
					<label>消费者旺旺:</label>
					<el-input v-model="postData.consumer_wangwang" placeholder="请输入消费者旺旺" class="seller_wangwang"></el-input>
				</div>
				<div class="item">
					<label>消费者姓名:</label>
					<el-input v-model="postData.consumer_name" placeholder="请输入消费者姓名" class="merchant_mobile"></el-input>
				</div>
			</div>
			<div class="item">
				<label>手机号码:</label>
				<el-input v-model="postData.consumer_mobile" placeholder="请输入消费者手机号" class="merchant_mobile"></el-input>
			</div>
    </div>
    <div>
    	<div class="title">售后授权</div>
    	<el-select v-model="postData.after_sale_type" placeholder="请选择授权方式" class="auth-select" clearable @change="authTypeChange">
		    <el-option
		      v-for="item in auth_types"
		      :key="item.type"
		      :label="item.label"
		      :value="item.type">
		    </el-option>
		  </el-select>
		  <div class="item" v-if="postData.after_sale_type === '2'">
				<span>允许最大补偿金额:</span>
				<el-input v-model="postData.compensation_price" placeholder="请输入补偿金额" class="compensation_price"></el-input>
			</div>
			<div class="commodity_url_input-wrap" v-if="postData.after_sale_type === '4'">
				<label>其他描述:</label>
				<el-input
          type="textarea"
          placeholder="请输入其他描述"
          v-model="postData.other_sale_massage"
          :rows="4"
          class="commodity_url_input"
          >
         </el-input>
			</div>
    </div>
    <div>
    	<div class="title">情况概括</div>
    	<div>请描述处理情况及给买家答应的条件</div>
    	<el-select v-model="postData.order_details_tag" placeholder="请选择大致情况" class="auth-select" clearable @change="authTypeChange">
		    <el-option
		      v-for="item in order_details_tag_list"
		      :key="item.id"
		      :label="item.label"
		      :value="item.label">
		    </el-option>
		  </el-select>
		  <div>
			  <el-input
	        type="textarea"
	        placeholder="请输入其他描述"
	        v-model="postData.order_details"
	        :rows="8"
	        class="order_details_input"
	        maxlength="1000"
	        show-word-limit
	        >
	       </el-input>
	    </div>
    </div>
    <div class="num">上传图片（{{ postData.order_images.length }}/9） （{{message}}）</div>
    <div>（正常尺寸通用）</div>
    <imageUpload v-model="postData.order_images" :limit="9"/>
    <div class="btns-wrap">
    	<el-button type="primary" class="confirmBtn" @click="submitOrderClick">确认</el-button>
	    <el-button @click="cancelCreateOrderClick">取消</el-button>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import imageUpload from '@/components/ImageUpload';
import { newOrder } from '@/api/order';

export default {
  name: 'addorder',
  data() {
  	return {
      auth_types: [
        {type: '1', label: '除处理费用外,商家还同意消费者申请退货退款'},
        {type: '2', label: '除处理费用外,商家还愿意额外支付消费者补偿款'},
        {type: '3', label: '除处理费用外,商家还同意消费者不退货仅退款'},
        {type: '4', label: '其他'},
      ],
      order_details_tag_list: [
         {id: '1', label: '电话联系不上'},
         {id: '2', label: '旺旺没搭理'},
         {id: '3', label: '答应消费者赔偿'},
         {id: '4', label: '答应消费者退货'},
         {id: '5', label: '消费者不同意删除'},
         {id: '6', label: '有沟通不愉快'},
         {id: '7', label: '收货人不是本人'},
         {id: '8', label: '其他'},
      ],
      isTaobaoProject: true,
      postData: {
        server_uuid: '',
  			salesman_uuid: '',
  			order_total_price: '',
  			question_url: '',
  			merchant_wangwang: '',
  			merchant_mobile: '',
        consumer_name: '',
        consumer_wangwang: '',
        consumer_mobile: '',
        after_sale_type: '',
        compensation_price: '',
        other_sale_massage: '',
        order_images: [],
        order_details: '',
        order_details_tag: '',
        commission_rate: '',
        server_type: '',
      },
      message: '', // 所选项目的提醒文字
  	}
  },
  computed: {
  	...mapState(['servicelist', 'salesman_list']),
  },
  components: {
    imageUpload,
  },
  mounted() {
    //默认选中最后一个项目
    let server_uuid = this.servicelist[this.servicelist.length-1].uuid;
    this.postData.server_uuid = server_uuid;
    this.selectProjectChange(server_uuid);
  },
  methods:  {
  	authTypeChange(value) {
  		console.log(value, 'change')
  	},
  	selectProjectChange(server_uuid) {
      if (!server_uuid) {
        this.postData.order_total_price = '';
        return
      }
      for (let i=0; i<this.servicelist.length; i++) {
      	let item = this.servicelist[i];
      	if (item.uuid === server_uuid) {
          this.postData.server_type = item.type;
          this.postData.order_total_price = item.server_price;
      		this.isTaobaoProject = item.type === '1' ? true : false;
          this.message = item.message;
      		break;
      	}
      }
  	},
  	async submitOrderClick() {
  		//提交数据验证
  		if(!this.postData.server_uuid) {
  			this.$message('请选择服务项目');
  			return
  		}
  		if(!this.postData.salesman_uuid) {
  			this.$message('请选择业务员');
  			return
  		}
  		if(!this.postData.order_total_price) {
  			this.$message('订单金额不能为空');
  			return
  		}
  		if(!this.postData.commission_rate) {
  			this.$message('佣金比例不能为空');
  			return
  		}
  		//佣金比例为1-100范围的整数
  		if (this.postData.commission_rate < 1 ||  this.postData.commission_rate > 100 || (this.postData.commission_rate%1 !== 0)) {
        this.$message('佣金比例为1～100范围的整数');
        return
  		}
  		if (!this.postData.question_url) {
        this.$message('商品链接不能为空');
  			return
  		}
  		if (this.isTaobaoProject && !this.postData.merchant_wangwang) {
  			this.$message('淘宝项目商家旺旺不能为空');
  			return
  		}
  		if (!(/^1[34578]\d{9}$/.test(this.postData.merchant_mobile))) {
  			this.$message('商家手机号格式错误');
  			return
  		}
  		if (this.isTaobaoProject && !this.postData.consumer_wangwang) {
  			this.$message('淘宝项目消费者旺旺不能为空');
  			return
  		}
  		if (!this.postData.consumer_name) {
        this.$message('消费者姓名不能为空');
  			return
  		}
  		if (!(/^1[34578]\d{9}$/.test(this.postData.consumer_mobile))) {
  			this.$message('消费者手机号格式错误');
  			return
  		}
      if (!this.postData.after_sale_type) {
        this.$message('请选择售后授权');
  			return
  		}
  		if (this.postData.after_sale_type === '2' && !this.postData.compensation_price) {
        this.$message('请输入最大允许补偿金额');
  			return
  		}
  		if (this.postData.after_sale_type === '4' && !this.postData.other_sale_massage) {
        this.$message('请输入其他信息');
  			return
  		}
  		if (!this.postData.after_sale_type) {
        this.$message('请选择售后授权');
  			return
  		}
  		if (!this.postData.order_details_tag) {
        this.$message('请选择大致情况');
  			return
  		}
  		if (!this.postData.order_images.length) {
        this.$message('至少上传一张图片');
  			return
  		}
  		this.postData.commission_rate /=100;
  		const { data, status } = await newOrder(this.postData);
  		if (status !== 200) return
  			console.log(data, '新建返回数据')
  		this.$router.go(-1);
  	},
  	cancelCreateOrderClick() {
  		this.$router.go(-1);
  	}
  },
}
</script>

<style lang="less" scoped>
.title {
  margin-bottom: 30px;
  font-size: 20px;
  font-family: PingFangSC-Medium;
  font-weight: 500;
  color: rgba(76,76,76,1);
  line-height: 28px
}
.item-wrap {
	display: flex;
}
.item {
	display: flex;
	align-items: center;
	margin-right: 80px;
	margin-bottom: 50px;
	.order_amount_input, .commission_rate_input, .seller_wangwang, .merchant_mobile, .compensation_price {
		width: 194px;
	}
}
label {
	width: 100px;
}
.commodity_url_input-wrap {
	display: flex;
  align-items: flex-start;
  margin-bottom: 30px;
	.commodity_url_input {
		width: 400px;
  }
  label {
    width: 120px;
  }
}
.seller-info-wrap {
	margin-top: 30px;
	margin-bottom: 30px;
}
.auth-select {
	width: 350px;
	margin-bottom: 15px;
}
.compensation_price {
	margin-left: 25px;
}
.order_details_input {
	width: 700px;
}
.num {
	margin-top: 30px;
}
.btns-wrap {
	margin-top: 30px;
	margin-bottom: 50px;
	text-align: center;
	.confirmBtn {
		margin-right: 30px;
	}
}
</style>
